import {Model} from '@vuex-orm/core';
import Oa from './Oa';

export default class Ie extends Model {
    static entity = 'ies';

    static fields () {
        return {
            id: this.number(0),
            oa_id: this.number(0),
            cod: this.string(''),
            name: this.string(''),
            rescheduled: this.boolean(false).nullable(),
            disabled: this.boolean(false),
            asignatura: this.string(''),
            asignatura_id: this.number(0),
            categoria: this.string(''),
            categoria_id: this.number(0),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            oa: this.belongsTo(Oa, 'oa_id'),
        };
    }
};
